import { UrlType } from 'src/app/shared/enum/url-type';
var IconPanelItemComponent = /** @class */ (function () {
    function IconPanelItemComponent() {
        this.contentVariant = null;
        this.urlType = UrlType;
    }
    Object.defineProperty(IconPanelItemComponent.prototype, "className", {
        get: function () { return 'icon-panel-item'; },
        enumerable: true,
        configurable: true
    });
    ;
    IconPanelItemComponent.prototype.ngOnInit = function () {
        if (this.data.link && this.data.link.value)
            this.contentVariant = this.data.link.value.type;
    };
    return IconPanelItemComponent;
}());
export { IconPanelItemComponent };
